import { RouterProvider } from "react-router-dom";
import { router } from "./routes/route";
import "./styles/global.scss";
import style from "./App.module.scss";

function App() {
  return (
    <div className={style["event-app"]}>
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </div>
  );
}

export default App;
